import { useQuery, type UseQueryOptions } from 'react-query'

import { getCurrentSubdomain } from '@webapp/api/integrations/hooks/utils'
import { integrationsClient, integrationsQueryKey } from '../client'
import type { Paths } from '../client'

type TData = Paths.ListIntegrations.Responses.$200
type TError = Paths.ListIntegrations.Responses.$422

export type GetListIntegrationsQueryConfig = Omit<
  UseQueryOptions<TData, TError>,
  'queryKey' | 'queryFn'
>

const queryKey = 'listIntegrations' as const

export const useGetIntegrationsQueryKey = queryKey

export const listIntegrations = async () => {
  const subdomain = getCurrentSubdomain()

  const response = await integrationsClient.listIntegrations({
    tenant: subdomain,
    'X-Procurify-Tenant': subdomain,
  })

  return response.data
}

export const useGetListIntegrations = (
  config?: Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery([integrationsQueryKey, queryKey], listIntegrations, config)
}
